import { TranslationMap } from '@trimble-gcs/i18n-types';

export function storageTranslations() {
  return {
    title: {
      text: $localize`:@@config.storage.title:{Reality Capture} Data Usage`,
      desc:
        'Title for the storage configuration page. ' +
        "The term 'Reality Capture' is the product name and is not translated.",
    },
    accountId: {
      text: $localize`:@@config.storage.accountId:Id`,
      desc: 'Label for the account id field.',
    },
    storageAvailable: {
      text: $localize`:@@config.storage.available:Storage Plan`,
      desc: 'Label for the total storage available field.',
    },
    storageUsed: {
      limitWarning: {
        text: $localize`:@@config.storage.used.limitWarning:Approaching storage limit. Storage remaining: {value}.`,
        desc:
          'Warning message displayed when storage is getting close to its maximum limit. ' +
          'The {value} is displayed in gigabytes (GB) or terabytes (TB).',
      },
      limitReached: {
        text: $localize`:@@config.storage.used.limitReached:Storage limit exceeded by {value}.`,
        desc:
          'Message displayed when storage usage exceeds the available storage.' +
          'The {value} is displayed in gigabytes (GB) or terabytes (TB).',
      },
      total: {
        text: $localize`:@@config.storage.usedTotal:Total Storage Used`,
        desc: 'Label for the total storage used field.',
      },
      allProjects: {
        text: $localize`:@@config.storage.usedGraph.allProjects:All Projects`,
        desc: 'Label for the total storage used shown in graph.',
      },
      currentProject: {
        text: $localize`:@@config.storage.usedGraph.currentProject:This Project`,
        desc: 'Label for the storage used by the current project shown in graph.',
      },
    },
    storageUsedByPojects: {
      title: {
        text: $localize`:@@config.storage.storageUsedByPojects:Storage Used per Project`,
        desc: 'Title text for the table showing account storage used per project.',
      },
    },
  } satisfies TranslationMap;
}
